import { traceMappingFlow } from './mappingTrace';

export const SlowMappingGateLogDelayMs = 8_000;
export const ProjectProfileVerifiedBannerVisibleMs = 4_000;
export type HostRibbonWorkspaceTab = 'mapping' | 'quickFill' | 'validation' | 'export';

// The ribbon contract is shared with the setup layout, so both routes describe the
// WPF shell with one set of types instead of private copies.
export type { HostRibbonCommand, HostRibbonWindow } from '../../../shared/lib/hostRibbon';

export const parseHostRibbonProfileKeys = (value: string | null | undefined): string[] => {
  if (!value) {
    return [];
  }

  try {
    const parsed: unknown = JSON.parse(value);
    if (!Array.isArray(parsed)) {
      return [];
    }

    return Array.from(new Set(
      parsed
        .filter((key): key is string => typeof key === 'string')
        .map((key) => key.trim())
        .filter(Boolean)
    ));
  } catch {
    return [];
  }
};

export const toHostRibbonWorkspaceTab = (activeTab: number): HostRibbonWorkspaceTab => {
  switch (activeTab) {
    case 1:
      return 'quickFill';
    case 2:
      return 'validation';
    case 3:
      return 'export';
    default:
      return 'mapping';
  }
};

export const normalizeHostRibbonWorkspaceTab = (
  value: string | null | undefined
): HostRibbonWorkspaceTab | null => {
  switch (value) {
    case 'mapping':
    case 'quickFill':
    case 'validation':
    case 'export':
      return value;
    default:
      return null;
  }
};

export const debugMappingPage = (message: string, payload?: Record<string, unknown>): void => {
  traceMappingFlow(
    message.replace(/^\[MappingConfigurationPage\]\s*/, 'mapping page '),
    payload
  );
};
